import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedPlatforms from './components/FeaturedPlatforms';
import CategorySection from './components/CategorySection';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '欧美无码正版内容平台推荐指南',
  url: 'https://yourdomain.com/',
  description: '为成年用户提供专业欧美无码平台评测、高清资源推荐与安全观看指南',
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://yourdomain.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'UltraGuide',
  url: 'https://yourdomain.com/',
  description: '欧美无码正版内容平台推荐指南',
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '什么是欧美无码正版内容平台？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '欧美无码正版内容平台是指获得合法授权、提供高清无码成人内容的专业流媒体服务。这些平台通常提供4K/8K超清画质、正版授权内容、安全的支付方式和完善的隐私保护措施。',
      },
    },
    {
      '@type': 'Question',
      name: '如何选择适合自己的欧美无码平台？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '选择平台时建议从内容偏好、预算范围、使用设备和是否需要多设备共享等维度考虑。建议先利用免费试用期体验不同平台。',
      },
    },
    {
      '@type': 'Question',
      name: '访问欧美无码平台需要注意哪些安全问题？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '建议使用VPN服务保护隐私、虚拟信用卡支付、独立邮箱注册、定期清理浏览记录、避免公共WiFi下访问。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="欧美无码正版内容平台推荐指南 | 高清无码平台评测与资源推荐"
        description="欧美无码正版内容平台推荐指南，为成年用户提供专业欧美无码平台评测、高清资源推荐、内容分类与在线观看指南。涵盖欧美无码高清、VR内容、直播互动等多种类型平台的详细评测。"
        keywords="欧美无码,欧美无码高清,欧美无码正版平台,欧美无码资源推荐,欧美无码在线观看,欧美无码视频分类,欧美无码平台评测"
        canonicalUrl="https://yourdomain.com/"
        schema={{ ...homeSchema, ...orgSchema, ...faqSchema }}
      />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedPlatforms />
          <CategorySection />
          <LatestArticles />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}